import React from 'react';
import { Helmet } from 'react-helmet';

interface CanonicalProps {
  url: string;
}

const Canonical: React.FC<CanonicalProps> = ({ url }) => {
  return (
    <Helmet>
      <link rel="canonical" href={url} />
    </Helmet>
  );
};

export default Canonical;
